import clsx from "clsx";
import React, { RefObject } from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Loader from "components/Loader";
import SearchNoResults from "components/SearchNoResults/SearchNoResults";
import { TSupportedEntity } from "utils/app-search-utils";
import { getEntityName } from "../helper";
import HorseItem from "./HorseItem";
import TrainerItem from "./TrainerItem";

import useStyles from "./styles";

interface IProps {
  items: TSupportedEntity[];
  isLoading: boolean;
  onClear: () => void;
  showClearSearchButton: boolean;
  value: string;
  searchValue: string;
  tableBodyRef: RefObject<HTMLUListElement>;
  onItemClick: (item: TSupportedEntity) => () => void;
  activeItemIndex: number;
  activeHorseId: string;
}

const SuggestionList = (props: IProps) => {
  const {
    isLoading,
    items,
    onClear,
    showClearSearchButton,
    value,
    searchValue,
    tableBodyRef,
    onItemClick,
    activeItemIndex,
    activeHorseId
  } = props;

  const classes = useStyles();

  if (isLoading) {
    return <Loader className={classes.searchLoader} size={31} />;
  }

  if (!items.length) {
    return (
      <SearchNoResults
        className={!showClearSearchButton && classes.searchNoResults}
        value={value}
        onClearSearch={onClear}
        showClearSearchButton={showClearSearchButton}
      />
    );
  }

  const renderItem = (item: TSupportedEntity) => {
    if (item instanceof racehorse360.Horse) {
      const isActiveHorseItem = [activeHorseId === item.id, !value].every(
        Boolean
      );

      return (
        <HorseItem
          horse={item}
          searchValue={searchValue}
          isActive={isActiveHorseItem}
        />
      );
    }

    return (
      <TrainerItem value={getEntityName(item)} searchValue={searchValue} />
    );
  };

  const listItems = items.map((item, index) => (
    <ListItem
      key={index}
      className={clsx(
        classes.dropDownSearchListItem,
        index % 2 ? classes.rowOdd : classes.rowEven,
        {
          [classes.activeDropDownSearchListItem]: index === activeItemIndex
        }
      )}
      component="li"
      divider
      onClick={onItemClick(item)}
    >
      {renderItem(item)}
    </ListItem>
  ));

  return (
    <List
      ref={tableBodyRef}
      component="ul"
      className={classes.dropDownSearchList}
      aria-label="drop-down search list"
      disablePadding
    >
      {listItems}
    </List>
  );
};

export default SuggestionList;
